import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

const RULES = [
    { label: "At least 8 characters", test: (v) => v.length >= 8 },
    { label: "Letters and numbers", test: (v) => /[A-Za-z]/.test(v) && /\d/.test(v) },
    { label: "An uppercase letter", test: (v) => /[A-Z]/.test(v) },
    { label: "A symbol (!@#$…)", test: (v) => /[^A-Za-z0-9]/.test(v) },
];

const COLORS = ["#FF3366", "#FF3366", "#FFB000", "#00C2FF", "#00E676"];
const LABELS = ["", "Weak", "Fair", "Good", "Strong"];

export function PasswordStrength({ value }) {
    const v = value || "";
    const passed = RULES.map((r) => r.test(v));
    const score = passed.filter(Boolean).length;
    const color = COLORS[score];

    return (
        <div className="mt-2 space-y-2" data-testid="password-strength">
            {v && (
                <>
                    <div className="flex gap-1.5">
                        {[1, 2, 3, 4].map((i) => (
                            <div key={i} className="h-1 flex-1 rounded-full transition-colors duration-300"
                                style={{ background: i <= score ? color : "#1f1f1f" }} />
                        ))}
                    </div>
                    <div className="flex items-center justify-between">
                        <span className="text-[11px] font-mono uppercase tracking-wider" style={{ color }}>{LABELS[score]}</span>
                    </div>
                    <div className="grid grid-cols-2 gap-1.5">
                        {RULES.map((r, i) => (
                            <div key={r.label} className={cn("flex items-center gap-1.5 text-[11px]", passed[i] ? "text-success" : "text-muted-foreground")}>
                                <Check className={cn("w-3 h-3", passed[i] ? "opacity-100" : "opacity-30")} /> {r.label}
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}
